export const steps = [
  {
    id: "3",
    title: "Set Your Goals",
    description: "Define what you're looking for in a college",
    completed: false,
    priority: "medium",
    estimatedTime: "3 minutes",
  },
  {
    id: "1",
    title: "Research Your College",
    description: "Learn about the college you're interested in",
    completed: false,
    priority: "high",
    estimatedTime: "5 minutes",
  },
  {
    id: "4",
    title: "Explore Financial Aid",
    description: "Learn about scholarships and financial options",
    completed: false,
    priority: "medium",
    estimatedTime: "5 minutes",
  },
  {
    id: "2",
    title: "Prepare for Admission",
    description: "Learn about the admission process and Visa requirements",
    completed: false,
    priority: "high",
    estimatedTime: "2 minutes",
  },
];

export const announcements = [
  {
    id: "1",
    title: "Welcome to OneGrad! 🎉",
    description:
      "Start by completing your profile to unlock personalized college recommendations",
    type: "general",
    date: "Just now",
    cta: "Get Started",
  },
  {
    id: "2",
    title: "New: AI-Powered College Matching",
    description:
      "Our advanced AI analyzes 50+ factors to find your perfect match",
    type: "general",
    date: "Today",
    cta: "Learn More",
    urgent: false,
  },
];

export const recommendedTimeline = {
  Fall: [
    {
      id: "1",
      title: "Submit Remaining Applications",
      description: "Complete applications to your remaining target colleges",
      date: "Due: Nov 30, 2025",
    },
    {
      id: "2",
      title: "Interview Preparation",
      description: "Prepare for upcoming college interviews",
      date: "Due: Dec 15, 2025",
    },
    {
      id: "3",
      title: "Financial Aid Applications",
      description: "Submit FAFSA and CSS Profile",
      date: "Due: Jan 15, 2026",
    },
    {
      id: "4",
      title: "Visa Filing",
      description: "Apply for student visa after acceptance",
      date: "Due: May 1, 2026",
    },
  ],

  Spring: [
    {
      id: "5",
      title: "Submit Remaining Applications",
      description: "Complete applications to your remaining target colleges",
      date: "Due: Mar 31, 2026",
    },
    {
      id: "6",
      title: "Interview Preparation",
      description: "Prepare for upcoming college interviews",
      date: "Due: Apr 15, 2026",
    },
    {
      id: "7",
      title: "Financial Aid Applications",
      description: "Submit FAFSA and CSS Profile",
      date: "Due: May 15, 2026",
    },
    {
      id: "8",
      title: "Visa Filing",
      description: "Apply for student visa after acceptance",
      date: "Due: Sep 1, 2026",
    },
  ],

  Summer: [
    {
      id: "9",
      title: "Submit Remaining Applications",
      description: "Complete applications to your remaining target colleges",
      date: "Due: Jul 31, 2026",
    },
    {
      id: "10",
      title: "Interview Preparation",
      description: "Prepare for upcoming college interviews",
      date: "Due: Aug 15, 2026",
    },
    {
      id: "11",
      title: "Financial Aid Applications",
      description: "Submit FAFSA and CSS Profile",
      date: "Due: Sep 15, 2026",
    },
    {
      id: "12",
      title: "Visa Filing",
      description: "Apply for student visa after acceptance",
      date: "Due: Jan 1, 2027",
    },
  ],
};
